import { render, staticRenderFns } from "./work-allocation.vue?vue&type=template&id=6d140eac&scoped=true"
import script from "./work-allocation.vue?vue&type=script&lang=js"
export * from "./work-allocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d140eac",
  null
  
)

export default component.exports